import React from "react";

import { Footer, Header, ScrollToTop, ScrollTop } from './components';
import { HomePage, ContactUs, AboutUs, TeamPage, TestimonialsPage, ServicePage, BlogGrid, BlogList, Checkout, Cart, Login, Register, ForgotPwd, GalleryPage, CarGrid, CarList, CarSingle, BlogSingle, ServiceSingle, BookingPage, ShopGrid, ShopList, ProductSingle, Wishlist, OrderConfirmation, TeamSingle, FaqPage, Error404, TermServices, PrivacyPolicy, PartnersPage, PortfolioPage, PortfolioSingle, CategoryPage } from './sections';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

 

const App = () => {

  return (
    <div className='App'> 

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes> 
 
        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/About-us' element={<AboutUs />} />
        <Route path='/Team' element={<TeamPage />} />  
        <Route path='/Team/:id' element={<TeamSingle />} />    
        <Route path='/Team/TeamSingle' element={<TeamSingle />} /> 
        <Route path='/Testimonials' element={<TestimonialsPage />} /> 
        <Route path='/Faqs' element={<FaqPage />} />    

        {/*Pages*/}
        <Route path='/Gallery' element={<GalleryPage />} />  
        <Route path='/Services' element={<ServicePage />} />
        <Route path='/Services/:id' element={<ServiceSingle />} />
        <Route path='/Services/Service-Single' element={<ServiceSingle />} />
        <Route path='/Portfolio' element={<PortfolioPage />} />
        <Route path='/Portfolio/:id' element={<PortfolioSingle />} />
        <Route path='/Portfolio/Portfolio-Single' element={<PortfolioSingle/>} />
        <Route path='/*' element={<Error404 />} />   
        <Route path='/Services-Terms' element={<TermServices />} />   
        <Route path='/Privacy-Policy' element={<PrivacyPolicy />} />   
        <Route path='/Partners' element={<PartnersPage />} />     

        {/*Cars*/}
        <Route path='/Car-Categories' element={<CategoryPage />} />
        <Route path='/Car-Grid' element={<CarGrid />} />  
        <Route path='/Car-List' element={<CarList />} /> 
        <Route path='/Cars' element={<CarGrid />} /> 
        <Route path='/Cars/search/:search' element={<CarGrid />} /> 
        <Route path='/Cars/:id' element={<CarSingle />} />
        <Route path='/Cars/Car-Single' element={<CarSingle />} />
        <Route path='/Car-Booking' element={<BookingPage />} />
  
        {/*Blogs*/}
        <Route path='/Blog-Grid' element={<BlogGrid />} /> 
        <Route path='/Blog-List' element={<BlogList />} /> 
        <Route path='/Blogs/search/:search' element={<BlogList />} /> 
        <Route path='/Blogs/tag/:tag' element={<BlogList />} /> 
        <Route path='/Blogs/category/:category' element={<BlogList />} /> 
        <Route path='/Blogs/:id' element={<BlogSingle  />} />
        <Route path='/Blogs/Blog-Single' element={<BlogSingle />} />
 
        {/*Shop*/}
        <Route path='/Shop-grid' element={<ShopGrid />} />  
        <Route path='/Shop/category/:category' element={<ShopList />} /> 
        <Route path='/Shop/tag/:tag' element={<ShopList />} /> 
        <Route path='/Shop/search/:search' element={<ShopList />} /> 
        <Route path='/Shop-list' element={<ShopList />} />
        <Route path='/Shop/:id' element={<ProductSingle />} />
        <Route path='/Shop/Product-Single' element={<ProductSingle />} /> 
        <Route path='/Wishlist' element={<Wishlist />} />
        <Route path='/Cart' element={<Cart />} />
        <Route path='/Checkout' element={<Checkout />} />
        <Route path='/OrderConfirmation' element={<OrderConfirmation />} />
        <Route path='/Login' element={<Login />} />  
        <Route path='/Register' element={<Register />} /> 
        <Route path='/Forgot-pwd' element={<ForgotPwd />} /> 

        {/*Contact*/}
        <Route path='/Contact-us' element={<ContactUs />} />

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />
      <ToastContainer />
    </div>
  )
}

export default App;
